module.exports = "<div class=\"progress-line\" [style.width.vw]=\"value\"></div>"